import { render, staticRenderFns } from "./EventLayout.vue?vue&type=template&id=34acf6e0&scoped=true"
import script from "./EventLayout.vue?vue&type=script&lang=js"
export * from "./EventLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34acf6e0",
  null
  
)

export default component.exports